import mBaseModel from '@/models/mBaseModel';
import UtilsData  from '@/utilities/UtilsData';
import moment     from 'moment';
import formatter  from '@/utilities/Formatter';

import { ModelFormatters } from '@/models/ModelFormatters';

export class ModelWithSmartProperties extends mBaseModel {
  constructor(rawModelFields = {}) {
    super(rawModelFields);
    return this;
  }

  setRawFields(rawModelFields = {}) {
    for (let [key, obj] of Object.entries(rawModelFields)) {
      this[key + '$'] = obj;
    }
    return this;
  }

  getRawFieldsFormattedForBackEnd() {
    const result = {};
    for (let key of Object.keys(this.ats)) {
      result[key] = this[key + '$'];
    }
    return result;
  }

  static setPropertyByPath(target, path, value) {
    var i;
    path = path.split('.');
    for (i = 0; i < path.length - 1; i++) {
      target = target[path[i]];
    }
    target[path[i]] = value;
  }
  
  static getPropertyByPath(target, path, value) {
    var i;
    path = path.split('.');
    for (i = 0; i < path.length - 1; i++) {
      if (path[i] in target) {
        target = target[path[i]];
      } else {
        return undefined;
      }
    }
    return target[path[i]];
  }

  defineModelProperty(modelPropertyName, propertyInfo = {}) {
    const {
      ToUserDataFormatter: toUserDataFormatter = ModelFormatters.ToUserData.Passthrough(),
      ToModelDataFormatter: toModelDataFormatter = ModelFormatters.ToModelData.Passthrough(),
    } = propertyInfo;

    const propertyPath = (modelPropertyName?.split('.') ?? []);
    
    const definePropertiesByPath = (target, path) => {
      for (let propToDefine of path.slice(0, -1)) {
        if (!(propToDefine in target)) {
          target[propToDefine] = {};
        }
        target = target[propToDefine];
      }
      return target; 
    }
    
    const smartPropertyTarget = definePropertiesByPath(this, propertyPath);
    const attributesRef = this.ats;
    Object.defineProperty(smartPropertyTarget, propertyPath.slice(-1) + '$', {
      enumerable: true,
      configurable: false,
      get: () => {
        const sourceValue = ModelWithSmartProperties.getPropertyByPath(attributesRef, modelPropertyName);
        return toModelDataFormatter(modelPropertyName, sourceValue);
      },
      set: (value) => {
        const targetValue = toUserDataFormatter(modelPropertyName, value);
        ModelWithSmartProperties.setPropertyByPath(attributesRef, modelPropertyName, targetValue);
      }
    });
  }
}
